module.exports = __webpack_public_path__ + "img/div11.f62104fa.png";